import React from "react";

function AddButton({ handleAdd, text, name }) {
  return (
    <div className="flex justify-end">
      <button
        className="hover:bg-emerald-200 hover:text-slate-900 transition text-slate-700 bg-emerald-100 px-2 py-1 text-xs font-semibold"
        onClick={handleAdd}
        name={name}
      >
        {text}
      </button>
    </div>
  );
}

export default AddButton;
